<template>
  <div>
    <nav-top @showProfile="showProfile" />
    <div class="container-fluid">
      <div class="row flex-xl-nowrap">
        <div :class="{ 'bd-banner-sidebar': isBannerEnabled }" class="col-12 col-md-3 col-xl-2 bd-sidebar">
          <nav-left />
          <pre class="small d-none d-md-block text-secondary"> v{{ version }} </pre>
        </div>
        <main class="col-12 col-md-9 col-xl-10 py-3 px-md-5 bd-content" role="main">
          <slot />
          <div class="d-md-none">
            <hr />
            <pre class="small text-secondary"> v{{ version }} </pre>
          </div>
        </main>
      </div>
    </div>
    <user-profile-dialog v-model="actionProfile" :value="actionProfile" @closing="closeModal" @send="savedUserProfile"
      @sendChangePassword="performChangeProfilePassword" />
    <dialog-password v-model="actionChangePassword" :value="actionChangePassword" @closing="closeModalPassword"
      @send="changeProfilePassword" />
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { users, lookups, auth } from '@/stores'
import NavTop from '@/components/navigation/nav-top.vue'
import NavLeft from '@/components/navigation/nav-left.vue'
import UserProfileDialog from '@/components/users/forms/user-profile-dialog.vue'
import DialogPassword from '@/components/users/forms/user-password.vue'
export default {
  name: 'layout-sidebar',
  components: {
    NavTop,
    NavLeft,
    UserProfileDialog,
    DialogPassword
  },
  data() {
    return {
      actionProfile: null,
      actionChangePassword: null
    }
  },
  computed: {
    ...mapState(auth, ['profile']),
    version() {
      let _version = window.version
      return _version
    },
    isBannerEnabled() {
      let env = window.config ? window.config.environment : ''
      return env !== 'prod'
    }
  },
  methods: {
    ...mapActions(lookups, ['setLookups']),
    ...mapActions(users, ['getUser', 'saveCredentials']),
    closeModal() {
      this.actionProfile = null
    },
    closeModalPassword() {
      this.actionChangePassword = null
    },
    async showProfile() {
      await this.setLookups({
        keys: [
          'ContactType',
          'Salutation',
          'AddressType',
          'PhoneType',
          'EmailType',
          'StateProvince',
          'Country',
          'RelatedContactType',
          'Language',
          'TimeZone'
        ],
        firm: this.profile.firm,
        refresh: false
      })
      await this.getUser(this.profile.username)
      let user = {
        firm: this.profile.firm,
        user: this.profile.user,
        contact: this.profile.contact,
        contactType: null,
        username: this.profile.username,
        emailAddress: this.profile.email,
        firstName: this.profile.firstName,
        lastName: this.profile.lastName,
        roles: this.profile.roles.toString(),
        password: ''
      }
      this.actionProfile = user
    },
    savedUserProfile() {
      this.actionProfile = null
    },
    performChangeProfilePassword() {
      this.actionProfile = null
      let data = {
        firstName: this.profile.firstName,
        lastName: this.profile.lastName,
        user: this.profile.user,
        contact: this.profile.contact,
        username: this.profile.username
      }
      this.actionChangePassword = data
    },
    async changeProfilePassword(data) {
      await this.saveCredentials(data)
      this.actionChangePassword = null
    }
  }
}
</script>
